import React from 'react';
import './style.scss';

export const ProfileContainer = ({children, id, className, mod = 'no-gutters', style}) => {
    return <div {...{id: id || null}} className={`container ${mod || ''} ${className || ''}`} style={style}>{children}</div>
};